import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import { FormHelperText, InputLabel, MenuItem, Select} from "@material-ui/core";
import IntlMessages from "../util/IntlMessages";
import {useForm} from "react-hook-form";
import { fetchUsers, masqueradeAsCustomer, masqueradeAsUser} from "../actions";
import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {isCurrentUserMemberOf} from "../util/bbHelpers";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(2),
        minWidth: 400,
    },
    root: {
        '& > *': {
            margin: theme.spacing(1),
            // width: '50ch',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Form = (props) => {
    const classes = useStyles();

  /**************************/
  /*Setup State and Dispatch*/
  /**************************/
    const {didJustCreateNewUser} = useSelector(({users}) => users.appMisc);
    const {customers} = useSelector(({customer}) => customer);
    const {users} = useSelector(({users}) => users);
    const {authUser, token, refreshToken} = useSelector(({auth}) => auth);
    // const customerMenuItems = customers
    //     ? Object.keys(customers)
    //     .map((keyName, i) =>
    //         (<MenuItem key={i} value={customers[keyName]["CustomerId"]}>{customers[keyName]["CustomerName"]} &nbsp;<small>{customers[keyName]["CustomerId"]}</small></MenuItem>
    // )) : null;
    const customerMenuItems = customers ? Object.values(customers) : null;
    if (customerMenuItems) {
        customerMenuItems.sort(function(a, b) {
            const textA = a.CustomerName.toUpperCase();
            const textB = b.CustomerName.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        })
    }

    // console.log("Masquerading users", users);

    const userMenuItems = users ? Object.values(users) : null;
    if (userMenuItems) {
        userMenuItems.sort(function(a, b) {
            const textA = a.last_name.toUpperCase();
            const textB = b.last_name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        })
    }

    // customerMenuItems
    //     .sort(function(a, b) {
    //     const textA = a.CustomerName.toUpperCase();
    //     const textB = b.CustomerName.toUpperCase();
    //     return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    // });
     // console.log("customers is", customers);
  const dispatch = useDispatch();

    const [customerId, setCustomerId] = useState(null);
    const [userId, setUserId] = useState(null);

    // const [localLoading, setLocalLoading] = useState(false);

    const clearForm = () => {
        setUserId("");
        const tempCustomerId = customerId;
        document.getElementById('NewUserForm').reset();
        setCustomerId(tempCustomerId ? tempCustomerId : "");
        document.getElementById('customerId').value = customerId;
    }

  useEffect(() => {
    if(didJustCreateNewUser) {
        clearForm();
    }

      if (users == null && isCurrentUserMemberOf(authUser,"admin")) {
          console.log("Users is empty, fetching.")
          dispatch(fetchUsers());
      }
    // setLocalLoading(false);
  }, [users, dispatch, didJustCreateNewUser]);

    const { register, handleSubmit, errors } = useForm();
    const onMasqueradeAsCustomerSubmit = data => {
        dispatch(masqueradeAsCustomer(customerId, token, refreshToken));
    }

    const onMasqueradeAsUserSubmit = data => {
        dispatch(masqueradeAsUser(userId, token, refreshToken));
    }

  /**************************/
  /*End Setup State and Dispatch*/
  /**************************/


    return (
        <div className="animated fadeIn animation-duration-7">




            <form id={"NewUserForm"} className={classes.root}>
                <div className={"row"}>
                    <div className={"col-6"}>
                        <h2>Masquerade as a User</h2>

                        <FormControl className={classes.formControl}>
                            <InputLabel
                                id="appModule.masqueradeAs.user-label"
                                required
                                error={!!errors.userId}
                            >
                                <IntlMessages id="appModule.masqueradeAs.user"/>
                            </InputLabel>
                            <Select
                                labelId="appModule.masqueradeAs.user-label"
                                id="userId"
                                name="userId"
                                value={userId}
                                onChange={(event) => setUserId(event.target.value)}
                                displayEmpty
                                // className={classes.selectEmpty}
                            >
                                {userMenuItems &&
                                    userMenuItems.map((user, i)=>
                                        (<MenuItem key={i} value={user["id"]}>{user["last_name"]}, {user["first_name"]} &nbsp;<small>({user["username"]}) {user["id"]}</small></MenuItem>
                                        ))
                                }

                            </Select>
                            <FormHelperText
                                error={!!errors.userId}
                            >
                                {errors.userId? errors.userId?.message : " "}
                            </FormHelperText>
                        </FormControl>
                        <br/>
                        <br/>
                        <div className="mb-3 d-flex align-items-center justify-content-between">

                            <Button onClick={handleSubmit(onMasqueradeAsUserSubmit)}
                                    disabled={!!errors.userId }
                                    variant="contained" color="primary">
                                <IntlMessages id="appModule.masqueradeAsUser.title"/>
                            </Button>
                            {/*{localLoading && <CircularProgress size={30}/>}*/}
                        </div>

                    </div>
                    <div className={"col-6"}>
                        <h2>Masquerade as a Company</h2>

                        <FormControl className={classes.formControl}>
                            <InputLabel
                                id="appModule.masqueradeAs.customer-label"
                                required
                                error={!!errors.customerId}
                            >
                                <IntlMessages id="appModule.masqueradeAs.customer"/>
                            </InputLabel>
                            <Select
                                labelId="appModule.masqueradeAs.customer-label"
                                id="customerId"
                                name="customerId"
                                value={customerId}
                                onChange={(event) => setCustomerId(event.target.value)}
                                displayEmpty
                                // className={classes.selectEmpty}
                            >
                                {customerMenuItems &&
                                    customerMenuItems.map((customer, i)=>
                                        (<MenuItem key={i} value={customer["CustomerId"]}>{customer["CustomerName"]} &nbsp;<small>{customer["CustomerId"]}</small></MenuItem>
                                        ))
                                }

                            </Select>
                            <FormHelperText
                                error={!!errors.customerId}
                            >
                                {errors.customerId? errors.customerId?.message : " "}
                            </FormHelperText>
                        </FormControl>
                        <br/>
                        <br/>
                        <div className="mb-3 d-flex align-items-center justify-content-between">

                            <Button onClick={handleSubmit(onMasqueradeAsCustomerSubmit)}
                                    disabled={!!errors.customerId}
                                    variant="contained" color="primary">
                                <IntlMessages id="appModule.masqueradeAsCustomer.title"/>
                            </Button>
                            {/*{localLoading && <CircularProgress size={30}/>}*/}
                        </div>

                    </div>
                </div>


            </form>

        </div>
    );



}

export default Form